import { CustomFields } from "./custom-fields";

export class Waiver {
    waiverId: number;
    waiverName: string;
    waiverText: string;
    minAgeOfConsent: string;
    email: string;
    password: string;
    signee: Guest;
    guests: GuestBase[];
    isRequireAcknowledgement: boolean;
    requirePasswordToLoadGuestData: boolean;
    waiverTemplateId: any;
    waiverLogoUrl: any;
    waiverCustomFields: CustomFields[]=[];
    guestCustomFields: CustomFields[]=[];
}

export class GuestBase {
    basicInfo: BasicInfo = new BasicInfo();
    waiverInfo: WaiverInfo = new WaiverInfo();
    selected: boolean = false;
    guestAccountId: number;
    guestAccountOwner : boolean;
    guestId: number;
    customFields: CustomFields[]=[];
    exists:boolean= false;
}

export class Guest extends GuestBase {
    contactInfo: ContactInfo = new ContactInfo();
    
}

export class BasicInfo {
    firstName: string;
    lastName: string;
    bMonth: number;
    bYear: number;
    bDate: number;
    birthDate: Date;
    IsMinor: boolean; //minor or adult
    displayInfo: string; // display header information
}
export class ContactInfo {
    contactInfo: ContactInfo;
    streetAddress: string;
    streetAddress2: string;
    city: string;
    state: string;
    zipCode: string;
    phone: string;
}

export class WaiverInfo {
    waiverStatus: string;
    hasCurrentWaiver: boolean
}

export class SignedWaiver {
    signedWaiverId: number;
    waiverId: number;
    parentGuestId: number;
    signedWaiverIdList: number[];
    waiverBody: string;
    waiverName: string;
    waiverText: string;
    guestAccountId: number;
    waiverSignConfig: number;
    minAgeOfConsent: number;
    isDisplayEmailOptOut: boolean;
    isMembershipPackageSaleOn: boolean;
    membershipPackageSaleOffMessage: string;
    isRequireAcknowledgement: boolean;
    isSignerAcknowledge: boolean;
    isEmailForMarketing: boolean;
    emailAddress: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    streetAddress: string;
    city: string;
    state: string;
    zipCode: string;
    guests: signWaiverGuest[];
    birthDay: string;
    birthdate: Date;
    parentBirthDay: string[];
    invalidWaiverUrl: string;
    signatureImage: string;
    waiverTemplateId: any;
    waiverLogoUrl: any;
    waiverCustomFieldFilledFormList : CustomFields[];
    pictureData: string;
}

export class signWaiverGuest {
    guestId: number
    firstName: string;
    lastName: string;
    birthDate: string;
    guestAccountOwner: boolean;
    birthDay: string;
    currentWaiverExpirationDate: Date
    hasCurrentWaiver: boolean
    streetAddress: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    emailAddress: string;
    phoneNumber: string;
    isMobile: boolean;
    language: string;
    signatureImage: string;
    pictureData: string;
    guestMembershipId: number;
    waiverCustomFieldFilledFormList: CustomFields[]
}